import React from 'react';
import { Spinner } from '@itglue/kaseya-ui';

type PropsType = {
    useOverlay?: boolean;
    size?: number;
    isAbsolutePosition?: boolean;
};

export const PageLoader = ({ useOverlay, size, isAbsolutePosition }: PropsType) => {
    return isAbsolutePosition ? (
            <>
                {useOverlay ? (
                    <div className='overlay overlay__absolute'>
                        <Spinner className='spinner spinner__absolute' size={size} />
                    </div>
                ) : (
                    <Spinner className='spinner spinner__absolute' size={size} />
                )}
            </>
    ) : (
        <>
            {useOverlay && <div className='overlay' />}
            <Spinner className='spinner' size={size} />
        </>
    );
};

export default PageLoader;
